import React from 'react';
import { useQuiz } from '../contexts/QuizContext';

const ProgressBar = () => {
  const { calculateProgress } = useQuiz();
  const progress = calculateProgress();

  return (
    <div className="w-full bg-gray-200 h-2">
      <div 
        className="progress-bar h-full" 
        style={{ width: `${progress}%` }}
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  );
};

export default ProgressBar;
